module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av421-955aae46ccab48393325fdd539c68f04.jpg";